import { ruleMessage } from '@cnamts/vue-dot/src/helpers/ruleMessage';
import { ErrorMessages } from '@cnamts/vue-dot/src/rules/types';

const defaultErrorMessages: ErrorMessages<number> = {
	default: 'Le champ est requis'
};

/** Check that the field exceeds the lengthValue length */
export function requiredBool(errorMessages = defaultErrorMessages) {
	// Return the validation function
	return (value: boolean) => null !== value || ruleMessage(errorMessages, 'default');
}

export default requiredBool;
